"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPace = exports.checkForOverridePaceUnits = exports.calculatePaceValue = exports.getPaceFromUnitType = exports.UnitType = exports.mapUnitsForConversions = exports.mapUnitsForMoment = exports.normalizePace = exports.findLabel = exports.findPaceLabel = exports.getPaceLabels = exports.PaceLabel = void 0;
var moment = require("moment");
var momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);
var convert = require("conversions");
var results_model_1 = require("@athlinks/results-model");
var unitLog_1 = require("./unitLog");
var __1 = require("..");
var distance_1 = require("./distance");
var time_1 = require("./time");
var lodash_1 = require("lodash");
var map = require("lodash/map");
// default time precision
// hours minutes seconds for default time
var PaceLabel;
(function (PaceLabel) {
    PaceLabel["MilesPerHour"] = "mph";
    PaceLabel["KilometersPerHour"] = "kph";
    PaceLabel["HectaMeterPerMinute"] = "100m/min";
    PaceLabel["HectaYardPerMinute"] = "100yd/min";
    PaceLabel["MinutePerMile"] = "min/mi";
    PaceLabel["MinutePerKilometer"] = "min/km";
    PaceLabel["MinutePerHectaYard"] = "min/100yd";
    PaceLabel["MinutePerHectaMeter"] = "min/100m";
})(PaceLabel = exports.PaceLabel || (exports.PaceLabel = {}));
var paceishLabelSetBuilder = function (paceType) { return function (subSet) {
    var _a, _b;
    var distanceUnit = subSet.distanceUnit, label = subSet.label, timeUnit = subSet.timeUnit;
    return _a = {},
        _a[distanceUnit] = (_b = {},
            _b[timeUnit] = {
                distanceUnit: distanceUnit,
                label: label,
                paceType: paceType,
                timeUnit: timeUnit
            },
            _b),
        _a;
}; };
var speedLabelSetBuilder = paceishLabelSetBuilder(results_model_1.PaceType.SPEED);
var paceLabelSetBuilder = paceishLabelSetBuilder(results_model_1.PaceType.PACE);
var hour = results_model_1.TimeUnit.HOURS, minute = results_model_1.TimeUnit.MINUTES, kilometers = results_model_1.DistanceUnit.KILO_METERS, hectaMeters = results_model_1.DistanceUnit.HECTA_METERS, miles = results_model_1.DistanceUnit.MILES, hectaYards = results_model_1.DistanceUnit.HECTA_YARDS;
var speedLabelSet = [
    {
        distanceUnit: miles,
        timeUnit: hour,
        label: PaceLabel.MilesPerHour
    }, {
        distanceUnit: kilometers,
        timeUnit: hour,
        label: PaceLabel.KilometersPerHour
    }, {
        distanceUnit: hectaMeters,
        timeUnit: minute,
        label: PaceLabel.HectaMeterPerMinute
    }, {
        distanceUnit: hectaYards,
        timeUnit: minute,
        label: PaceLabel.HectaYardPerMinute
    }
];
var paceLabelSet = [
    {
        distanceUnit: miles,
        timeUnit: minute,
        label: PaceLabel.MinutePerMile
    }, {
        distanceUnit: kilometers,
        timeUnit: minute,
        label: PaceLabel.MinutePerKilometer
    }, {
        distanceUnit: hectaMeters,
        timeUnit: minute,
        label: PaceLabel.MinutePerHectaMeter
    }, {
        distanceUnit: hectaYards,
        timeUnit: minute,
        label: PaceLabel.MinutePerHectaYard
    }
];
exports.getPaceLabels = function (paceType) {
    switch (paceType) {
        case results_model_1.PaceType.PACE: return paceLabelSet;
        case results_model_1.PaceType.SPEED: return speedLabelSet;
        default: return undefined;
    }
};
var paceMapBuilder = function (paceLabelBuilder) { return function (labelSet) { return lodash_1.flow(lodash_1.partialRight(map, paceLabelBuilder), lodash_1.partialRight(lodash_1.reduce, function (paceLabelCollection, smallCollection) { return (__assign(__assign({}, paceLabelCollection), smallCollection)); }, {}))(labelSet); }; };
var buildPaceLabelMap = function () {
    var _a;
    return (_a = {},
        _a[results_model_1.PaceType.SPEED] = paceMapBuilder(speedLabelSetBuilder)(speedLabelSet),
        _a[results_model_1.PaceType.PACE] = paceMapBuilder(paceLabelSetBuilder)(paceLabelSet),
        _a);
};
var defaultPaceLabelMap = buildPaceLabelMap();
function findPaceLabel(paceType, distanceUnit, timeUnit) {
    try {
        return defaultPaceLabelMap[paceType][distanceUnit][timeUnit].label;
    }
    catch (_a) {
        return undefined;
    }
}
exports.findPaceLabel = findPaceLabel;
function findLabel(pace, capitalize) {
    var timeUnit = pace.time.timeUnit, distanceUnit = pace.distance.distanceUnit, paceType = pace.paceType;
    if (paceType === results_model_1.PaceType.NOTCALCULATED) {
        return pace.time.timeUnit;
    }
    var computedLabel = (paceType === results_model_1.PaceType.SPEED) ? distanceUnit + "/" + timeUnit :
        timeUnit + "/" + distanceUnit;
    var paceLabel = findPaceLabel(paceType, distanceUnit, timeUnit);
    var maybeLabel = paceLabel ? paceLabel : computedLabel;
    var label = undefined;
    if (!maybeLabel) {
        unitLog_1.UnitLog.warn('You asked for a default label, ' +
            'but none could be found. Use ' +
            ("the label '" + computedLabel + "' or ignore the label type."));
        label = computedLabel;
    }
    else {
        label = maybeLabel;
    }
    return (capitalize) ? label.toUpperCase() : label;
}
exports.findLabel = findLabel;
function buildNormalizedPaceMap() {
    var paceMap = {};
    var mph = {
        timeUnit: results_model_1.TimeUnit.HOURS,
        distanceUnit: results_model_1.DistanceUnit.MILES,
        paceType: results_model_1.PaceType.SPEED
    };
    var minPerMile = {
        timeUnit: results_model_1.TimeUnit.MINUTES,
        distanceUnit: results_model_1.DistanceUnit.MILES,
        paceType: results_model_1.PaceType.PACE
    };
    var hectaMeterPerMin = {
        timeUnit: results_model_1.TimeUnit.MINUTES,
        distanceUnit: results_model_1.DistanceUnit.HECTA_METERS,
        paceType: results_model_1.PaceType.PACE
    };
    paceMap[results_model_1.IntervalRaceType.CYCLING] = function () { return mph; };
    paceMap[results_model_1.IntervalRaceType.RUNNING] = function () { return minPerMile; };
    paceMap[results_model_1.IntervalRaceType.SWIM] = function () { return hectaMeterPerMin; };
    paceMap[results_model_1.IntervalRaceType.TRANSITION] = function () { return minPerMile; };
    paceMap[results_model_1.IntervalRaceType.UNDEFINED] = function () { return minPerMile; };
    return paceMap;
}
var normalizedPaceMap = buildNormalizedPaceMap();
function normalizePace(pace, intervalRaceType) {
    if (pace.paceType !== results_model_1.PaceType.NOTCALCULATED) {
        return pace;
    }
    var distance = pace.distance, time = pace.time;
    if (!intervalRaceType) {
        unitLog_1.UnitLog.warn('Could not find interval race type. ' +
            'Defaulting to MIN/MI as your pace type.');
    }
    var _a = normalizedPaceMap[intervalRaceType](), distanceUnit = _a.distanceUnit, timeUnit = _a.timeUnit, paceType = _a.paceType;
    return {
        distance: {
            distanceInMeters: distance.distanceInMeters,
            distanceUnit: distanceUnit
        },
        time: {
            timeInMillis: time.timeInMillis,
            timeUnit: timeUnit
        },
        paceType: paceType
    };
}
exports.normalizePace = normalizePace;
function mapUnitsForMoment(timeUnit) {
    switch (timeUnit) {
        case results_model_1.TimeUnit.MILLI_SECONDS:
            return 'milliseconds';
        case results_model_1.TimeUnit.SECONDS:
            return 'seconds';
        case results_model_1.TimeUnit.HOURS:
            return 'hours';
        case results_model_1.TimeUnit.MINUTES:
            return 'minutes';
    }
}
exports.mapUnitsForMoment = mapUnitsForMoment;
function mapUnitsForConversions(distanceUnit) {
    switch (distanceUnit) {
        case results_model_1.DistanceUnit.FEET:
            return 'feet';
        case results_model_1.DistanceUnit.HECTA_METERS:
        case results_model_1.DistanceUnit.METERS:
            return 'meters';
        case results_model_1.DistanceUnit.HECTA_YARDS:
        case results_model_1.DistanceUnit.YARDS:
            return 'yards';
        case results_model_1.DistanceUnit.KILO_METERS:
            return 'kilometers';
        case results_model_1.DistanceUnit.MILES:
            return 'miles';
    }
}
exports.mapUnitsForConversions = mapUnitsForConversions;
var UnitType;
(function (UnitType) {
    UnitType["DEFAULT"] = "default";
    UnitType["METRIC"] = "metric";
    UnitType["IMPERIAL"] = "imperial";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
// only support changing mph to kph and min/mi to min/km
var getMilesOrKilosDistanceUnit = function (unitType) {
    if (unitType === UnitType.IMPERIAL) {
        return results_model_1.DistanceUnit.MILES;
    }
    return results_model_1.DistanceUnit.KILO_METERS;
};
function getPaceFromUnitType(pace, unitType) {
    var defaultPace = __assign({}, pace);
    if (unitType === UnitType.DEFAULT) {
        return defaultPace;
    }
    var distUnit = pace.distance.distanceUnit;
    var convertingMilesOrKm = distUnit === results_model_1.DistanceUnit.MILES
        || distUnit === results_model_1.DistanceUnit.KILO_METERS;
    if (!convertingMilesOrKm) {
        return defaultPace;
    }
    var mappedDistanceUnit = getMilesOrKilosDistanceUnit(unitType);
    var newDistance = {
        distanceInMeters: pace.distance.distanceInMeters,
        distanceUnit: mappedDistanceUnit
    };
    var newPace = __assign(__assign({}, pace), { distance: newDistance });
    return newPace;
}
exports.getPaceFromUnitType = getPaceFromUnitType;
function calculatePaceValue(pace, args) {
    var time = pace.time, timeUnit = pace.time.timeUnit, distance = pace.distance, distanceUnit = pace.distance.distanceUnit, paceType = pace.paceType;
    var intervalRaceType = args.intervalRaceType;
    var timeArgsTemp = args;
    var roundUpSeconds = lodash_1.isBoolean(timeArgsTemp.roundUpSeconds) ?
        timeArgsTemp.roundUpSeconds : false;
    var timeArgs = __assign(__assign({}, timeArgsTemp), { roundUpSeconds: roundUpSeconds });
    var distArgsTemp = args.conversionArgs;
    var precision = (distArgsTemp && distArgsTemp.precision) ?
        distArgsTemp.precision : 2;
    var distArgs = __assign(__assign({}, distArgsTemp), { precision: precision });
    switch (paceType) {
        case results_model_1.PaceType.NOTCALCULATED:
        case results_model_1.PaceType.PACE:
            // transitions are a special case
            if (intervalRaceType === results_model_1.IntervalRaceType.TRANSITION) {
                return __1.convertTime(time, args.conversionArgs).value;
            }
            var timeForDistance = time_1.convertTimeValue(time) /
                distance_1.convertDistanceValue(distance, distArgs);
            var timeInMillis = moment.duration(timeForDistance, mapUnitsForMoment(timeUnit)).asMilliseconds();
            return __1.convertTime({
                timeInMillis: timeInMillis,
                timeUnit: timeUnit
            }, timeArgs).value;
        case results_model_1.PaceType.SPEED:
            var distForTime = distance_1.convertDistanceValue(distance, distArgs) /
                time_1.convertTimeValue(time);
            var distanceInMeters = (distanceUnit === results_model_1.DistanceUnit.HECTA_METERS ||
                distanceUnit === results_model_1.DistanceUnit.HECTA_YARDS) ?
                convert(distForTime * 100, mapUnitsForConversions(distanceUnit), 'meters') / 100 :
                convert(distForTime, mapUnitsForConversions(distanceUnit), 'meters');
            return distance_1.convertDistance({
                distanceInMeters: distanceInMeters,
                distanceUnit: distanceUnit
            }, distArgs).value.toString();
    }
}
exports.calculatePaceValue = calculatePaceValue;
function checkForOverridePaceUnits(pace, args) {
    if (args === void 0) { args = {}; }
    var overridePaceUnits = args.overridePaceUnits;
    return (overridePaceUnits) ? __assign(__assign({}, pace), { distance: {
            distanceInMeters: pace.distance.distanceInMeters,
            distanceUnit: overridePaceUnits.distanceUnit
        }, time: {
            timeInMillis: pace.time.timeInMillis,
            timeUnit: overridePaceUnits.timeUnit
        } }) : pace;
}
exports.checkForOverridePaceUnits = checkForOverridePaceUnits;
function convertPace(pace, args) {
    if (args === void 0) { args = {}; }
    var _a = args.capitalizeLabel, capitalizeLabel = _a === void 0 ? true : _a, intervalRaceType = args.intervalRaceType;
    var _b = checkForOverridePaceUnits(pace), _c = _b.distance, distanceInMeters = _c.distanceInMeters, distanceUnit = _c.distanceUnit, _d = _b.time, timeInMillis = _d.timeInMillis, timeUnit = _d.timeUnit;
    if (distanceInMeters < 0 || timeInMillis < 0) {
        unitLog_1.UnitLog.warn("Negative values found in pace (distance = " +
            (distanceInMeters + ", time = " + timeInMillis + "), returning empty pace."));
        return {
            value: '',
            label: ''
        };
    }
    var normalizedPace = normalizePace(pace, intervalRaceType);
    var paceType = normalizedPace.paceType;
    try {
        return {
            value: calculatePaceValue(normalizedPace, args),
            label: findLabel(normalizedPace, capitalizeLabel)
        };
    }
    catch (err) {
        if (paceType === results_model_1.PaceType.SPEED) {
            unitLog_1.UnitLog.warn("Could not convert " +
                (distanceInMeters + " meters per " + timeInMillis + " ms ") +
                ("to pace '" + distanceUnit + "/" + timeUnit + "'."));
            return {
                value: "" + distanceInMeters / timeInMillis,
                label: results_model_1.DistanceUnit.METERS + "/" + results_model_1.TimeUnit.MILLI_SECONDS
            };
        }
        else {
            unitLog_1.UnitLog.warn("Could not convert " +
                (timeInMillis + " ms per " + distanceInMeters + " meters ") +
                ("to pace '" + timeUnit + "/" + distanceUnit + "'."));
            return {
                value: "" + timeInMillis / distanceInMeters,
                label: results_model_1.TimeUnit.MILLI_SECONDS + "/" + results_model_1.DistanceUnit.METERS
            };
        }
    }
}
exports.convertPace = convertPace;
//# sourceMappingURL=pace.js.map